/*
 * CV2 Smart Product Finder.
 *
 * Three questions (trip type, cooling hours, pens carried), then a scored
 * recommendation. Products and their matching criteria come from section
 * blocks, serialised into a JSON script tag - no network call to score.
 */
(function () {
  function init() {
    var root = document.querySelector('[data-cv2-finder]');
    if (!root || root.dataset.cv2Bound) return;
    root.dataset.cv2Bound = '1';

    var data = [];
    var dataEl = root.querySelector('[data-cv2-finder-data]');
    try { data = JSON.parse(dataEl.textContent) || []; } catch (e) { data = []; }

    var panels = root.querySelectorAll('[data-cv2-step]');
    var dots = root.querySelectorAll('[data-cv2-step-dot]');
    var back = root.querySelector('[data-cv2-back]');
    var results = root.querySelector('[data-cv2-results]');
    var resultMeta = root.querySelector('[data-cv2-result-meta]');
    var range = root.querySelector('[data-cv2-answer="pens"]');
    var penOut = root.querySelector('[data-cv2-pen-value]');

    var answers = { trip: null, hours: null, pens: range ? Number(range.value) : 2 };
    var step = 1;

    function show(which) {
      step = which;
      panels.forEach(function (p) {
        var isMatch = p.getAttribute('data-cv2-step') === String(which);
        p.hidden = !isMatch;
        p.classList.toggle('is-active', isMatch);
      });
      dots.forEach(function (d) {
        var n = Number(d.getAttribute('data-cv2-step-dot'));
        var active = which === 'results' ? n <= 3 : n <= Number(which);
        d.classList.toggle('is-active', active);
        d.classList.toggle('is-current', String(n) === String(which));
      });
      if (back) back.hidden = (which === 1);
    }

    function score(p) {
      var s = 0;
      if (answers.trip) {
        var trips = String(p.trips || '').split(',').map(function (t) { return t.trim(); });
        if (trips.indexOf(answers.trip) !== -1) s += 2;
      }
      if (answers.hours) {
        // must cover the requested duration; closest sufficient product wins
        if (p.maxHours >= answers.hours) {
          s += 3;
          s -= Math.min(2, (p.maxHours - answers.hours) / 24);
        } else {
          s -= 2;
        }
      }
      if (answers.pens) {
        if (answers.pens >= p.minPens && answers.pens <= p.maxPens) s += 3;
        else if (answers.pens > p.maxPens) s -= 1.5;
        else s -= 0.5;
      }
      if (p.available === false) s -= 1;
      return s;
    }

    function esc(v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function render() {
      if (!data.length) {
        results.innerHTML = '<p class="cv2-finder__none">No products are set up for the finder yet.</p>';
        return;
      }
      var ranked = data.slice().sort(function (a, b) { return score(b) - score(a); }).slice(0, 3);

      if (resultMeta) {
        var bits = [];
        if (answers.trip) bits.push(answers.trip.replace(/-/g, ' '));
        if (answers.hours) bits.push(answers.hours >= 48 ? '24+ hrs' : 'up to ' + answers.hours + ' hrs');
        bits.push(answers.pens + (answers.pens === 1 ? ' pen' : ' pens'));
        resultMeta.textContent = bits.join(' · ');
      }

      results.innerHTML = ranked.map(function (p, i) {
        var img = p.image
          ? '<img src="' + esc(p.image) + '" alt="" width="72" height="72" loading="lazy">'
          : '<span class="cv2-finder__hit-blank"></span>';
        return '<a class="cv2-finder__hit' + (i === 0 ? ' is-best' : '') + '" href="' + esc(p.url) + '">' +
                 '<span class="cv2-finder__hit-img">' + img + '</span>' +
                 '<span class="cv2-finder__hit-text">' +
                   (i === 0 ? '<span class="cv2-finder__badge">Best match</span>' : '') +
                   '<span class="cv2-finder__hit-title">' + esc(p.title) + '</span>' +
                   (p.blurb ? '<span class="cv2-finder__hit-blurb">' + esc(p.blurb) + '</span>' : '') +
                   '<span class="cv2-finder__hit-price">' + esc(p.price) + '</span>' +
                 '</span>' +
               '</a>';
      }).join('');
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-cv2-answer]');
      if (opt && opt.tagName === 'BUTTON') {
        var key = opt.getAttribute('data-cv2-answer');
        var val = opt.getAttribute('data-cv2-value');
        answers[key] = key === 'hours' ? Number(val) : val;

        // single-select within this step
        var group = opt.parentElement.querySelectorAll('[data-cv2-answer="' + key + '"]');
        group.forEach(function (b) { b.classList.toggle('is-picked', b === opt); });

        window.setTimeout(function () { show(step === 1 ? 2 : 3); }, 160);
        return;
      }
      if (e.target.closest('[data-cv2-finish]')) { render(); show('results'); return; }
      if (e.target.closest('[data-cv2-restart]')) {
        answers = { trip: null, hours: null, pens: range ? Number(range.value) : 2 };
        root.querySelectorAll('.is-picked').forEach(function (b) { b.classList.remove('is-picked'); });
        show(1);
        return;
      }
      if (e.target.closest('[data-cv2-back]')) {
        show(step === 'results' ? 3 : Math.max(1, Number(step) - 1));
      }
    });

    if (range && penOut) {
      var sync = function () {
        answers.pens = Number(range.value);
        penOut.textContent = range.value;
        // paint the filled portion of the track
        var pct = ((range.value - range.min) / (range.max - range.min)) * 100;
        range.style.setProperty('--cv2-range-pct', pct + '%');
      };
      range.addEventListener('input', sync);
      sync();
    }

    show(1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
